import { render, staticRenderFns } from "./Parceria_SindirepaRioDeJaneiro.vue?vue&type=template&id=e1f83c44"
import script from "./Parceria_SindirepaRioDeJaneiro.vue?vue&type=script&lang=js"
export * from "./Parceria_SindirepaRioDeJaneiro.vue?vue&type=script&lang=js"
import style0 from "./Parceria_SindirepaRioDeJaneiro.vue?vue&type=style&index=0&id=e1f83c44&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports